export default "__VITE_ASSET__9wRc7SOH__"